import React, { useState, useEffect, forwardRef } from 'react';
import { maskCell, maskPhone } from '~/helpers/utils/Masks';
import InputComponent from '../InputComponent';
import { Controller } from 'react-hook-form';

/* Input password */
const InputPhoneComponent = forwardRef((props, ref) => {
  const [currenMask, setMask] = useState(maskCell);
  const {
    control,
    minLength = '14',
    name = 'phone',
    id = 'phone',
    defaultValue,
    mask = maskCell,
    ...otherProps
  } = props;

  useEffect(() => {
    if (defaultValue) {
      const with9 = defaultValue.length === 15;

      setMask(with9 ? maskCell : maskPhone);
    }
  }, [defaultValue]);

  // Ao digitar verifico se está aumentando ou diminuindo o tamanho dos values,
  // e assim trocamos as mascaras.
  const handleKeyDown = (e) => {
    const with9 = e.target.value.length + 1 > 14;

    setMask(with9 ? maskCell : maskPhone);
  };

  // Passa valores para o phone
  return (
    <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <InputComponent
            onKeyDown={handleKeyDown}
            name={name}
            id={id}
            mask={currenMask}
            ref={ref}
            defaultValue={defaultValue}
            {...otherProps}
            {...field}
          />
        )}
    />
  );
});

export default InputPhoneComponent;
